'use strict';

var anObject = require('../internals/an-object');

var aFunction = require('../internals/a-function');

var iterate = require('../internals/iterate'); // `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods


require('../internals/export')({
  target: 'Map',
  proto: true,
  real: true,
  forced: require('../internals/is-pure')
}, {
  // eslint-disable-next-line no-unused-vars
  merge: function merge(iterable
  /* ...iterbles */
  ) {
    var map = anObject(this);
    var setter = aFunction(map.set);
    var i = 0;

    while (i < arguments.length) {
      iterate(arguments[i++], setter, map, true);
    }

    return map;
  }
});